// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-module--title--2on6P"};